import { createAction } from 'redux-actions';


const logout = createAction('AUTH:LOGOUT');


export { logout };


// WEBPACK FOOTER //
// ./src/modules/auth/actions/logout.js